export const ACTION_PREFIX = 'ID_VERIFICATION';
// eslint-disable-next-line max-len
export const ID_VERIFICATION_FAILED_ERROR =
  'Identity verification failed :  please check that your details below match your identity document and try again.';

export const actionTypes = {
  UPDATE_ID_VERIFICATION_RESULT: 'UPDATE_ID_VERIFICATION_RESULT',
  UPDATE_ERROR_MESSAGE: 'UPDATE_ERROR_MESSAGE',
  UPDATE_DIRECTOR_LIST: 'UPDATE_DIRECTOR_LIST',
  RESET_ID_VERIFICATION_RESULT: 'RESET_ID_VERIFICATION_RESULT',
  UPDATE_HAS_ERRORED_FROM_VERIFY_ID_PREFILLED: 'UPDATE_HAS_ERRORED_FROM_VERIFY_ID_PREFILLED',
  UPDATE_SHADOW_REGISTERED_ACCOUNT_DETAILS: 'UPDATE_SHADOW_REGISTERED_ACCOUNT_DETAILS',
  UPDATE_CONTACT_REGISTER_RESULT: 'UPDATE_CONTACT_REGISTER_RESULT',
  UPDATE_IS_VERIFY_ID_PREFILLED_ERROR: 'UPDATE_IS_VERIFY_ID_PREFILLED_ERROR',
};

export const myNameIsNotHere = { id: false, text: 'My name is not here' };

export const PASSPORT_TOOLTIP =
  'To verify your Travel Document it must not have expired more than 3 years ago.';
